import { render, staticRenderFns } from "./SquatationIndex.vue?vue&type=template&id=dbb39a74"
import script from "./SquatationIndex.vue?vue&type=script&lang=js"
export * from "./SquatationIndex.vue?vue&type=script&lang=js"
import style0 from "./SquatationIndex.vue?vue&type=style&index=0&id=dbb39a74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports